import React from 'react'
import { graphql } from 'gatsby'
import Section from '../components/Section'
import Layout from '../components/PageLayout'
import Recap from '../components/Recap';
import { format } from '../utils/utils'

export default ({data}) => {
  
  const allActivities = []
  data.allWeeks.edges.forEach(week => {
    const activitie = {
      semaine: week.node.semaine,
      members: week.node.membres,
      activities: format(week.node.nombredactivites),
      distance: `${format(week.node.strdistance.replace('_', ''))} km`,
      time: week.node.tempshhmmss.slice(0, -3).replace(':', 'h'),
      elevation: format(week.node.elevationm)
    }
    allActivities.push(activitie)
  });

  return (
    <Layout>
      <Section 
        title="Semaine par Semaine..." 
        id="weekbyweek" 
        color='background'
      >
        <Recap activities={allActivities}/>
      </Section>
    </Layout>
  )
}


export const query = graphql`
  query allWeeksQuery {

    allWeeks: allGoogleSheetStatsRow(sort: {fields: semaine, order: DESC}) {
      edges {
        node {
          id
          nombredactivites
          semaine
          distancekm
          tempshhmmss
          elevationm
          strdistance
          membres
        }
      }
    }
  }
`
